export const DOCS_HOME_PATH = '/docs'

/** GrowthBook (JSON) feature that controls the docs help icon, independent of the route/ACL config. */
export const PAGE_DOCS_FEATURE_KEY = 'emd-page-docs'

export interface PageDocsConfig {
  enabled: boolean
  slug: string | null
}

/** Key of the page in the `emd-page-docs` map: the first path segment ("/se-metrics/x" -> "se-metrics"), "home" for "/". */
export const getPageDocsKey = (pathname: string): string => {
  const [firstSegment] = pathname.split('/').filter(segment => segment !== '')
  return firstSegment === undefined ? 'home' : firstSegment.toLowerCase()
}

/** Parse one entry of the `emd-page-docs` map: `{"enabled": true, "slug": "se-metrics"}`. */
export const parsePageDocsConfig = (raw: unknown): PageDocsConfig => {
  if (typeof raw !== 'object' || raw === null || Array.isArray(raw)) return {enabled: false, slug: null}

  const {enabled, slug} = raw as {enabled?: unknown; slug?: unknown}
  if (enabled !== true) return {enabled: false, slug: null}

  const trimmedSlug = typeof slug === 'string' ? slug.trim() : ''
  return {enabled: true, slug: trimmedSlug === '' ? null : trimmedSlug}
}

/** Resolve the docs config of a page from the raw `emd-page-docs` map, e.g. `{"se-metrics": {"enabled": true, "slug": "se-metrics"}}`. */
export const resolvePageDocs = (rawMap: unknown, pathname: string): PageDocsConfig => {
  if (typeof rawMap !== 'object' || rawMap === null || Array.isArray(rawMap)) return {enabled: false, slug: null}

  return parsePageDocsConfig((rawMap as Record<string, unknown>)[getPageDocsKey(pathname)])
}
